var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.762 21.264L13.9087 11.2728L13.9204 11.2821L20.0996 4.12109H18.0347L13.0009 9.94966L9.00354 4.12109H3.58795L9.98614 13.4491L9.98536 13.4484L3.2373 21.264H5.30224L10.8986 14.7793L15.3464 21.264H20.762ZM8.18536 5.67954L17.8009 19.7055H16.1646L6.5412 5.67954H8.18536Z",
    fill: "#56565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e955c1d3cc34764978e8f7a389bc883c.svg";
export { ForwardRef as ReactComponent };